import { assertNonNullable } from "@neonaut/lib-js/nonNullable";
export default function getCentroid([top, right, bottom, left]) {
    assertNonNullable(top);
    assertNonNullable(bottom);
    assertNonNullable(right);
    assertNonNullable(left);
    return [top + (bottom - top) / 2, right + (left - right) / 2];
}
